export default __webpack_public_path__ + "static/media/consultationIcon.99f7defa.svg";